import 'styles/generic/endOfPageCtaWithForm.less';

import { G2Badges } from 'components/badges/G2Badges';
import { ContactOptionsInline } from 'components/forms/getStartedForm/ContactOptionsInline';
import React from 'react';

import { CustomerLogos } from './customers/CustomerLogos';
import { MosaicBg } from 'components/tsxCommon/MosaicBg';
import { SignupForm } from 'components/forms/getStartedForm/SignupForm';
import { GatsbyImage } from 'gatsby-plugin-image';

const EndOfPageCtaWithForm = ({
    background = 'linear-gradient(122.93deg, #1eafaa 0%, #114b5c 100%)',
    customParagraph,
    formId,
    header,
    includeBadges = true,
    includeContactOptions,
    includeCustomerLogos,
    paragraph,
    useBannerBg = true,
    customerQuote
}) => {
    return (
        <div
            className="lg:tw-py-[100px] tw-py-48 tw-flex tw-items-center tw-justify-center tw-px-24 tw-rounded tw-relative"
            style={{ background: useBannerBg ? '#222' : background }}
        >
            {useBannerBg ? <MosaicBg /> : null}
            <div className="tw-flex lg:tw-flex-row tw-flex-col tw-justify-center lg:tw-gap-[100px] tw-gap-48 tw-items-center tw-relative ">
                <div
                    className={`${!customerQuote && 'tw-max-w-[500px]'} tw-text-neutral-inverse md:tw-px-[40px] sm:tw-px-0 sm:tw-py-0 tw-prose tw-mx-auto tw-text-center`}
                >
                    <h2 className="tw-text-neutral-inverse tw-font-bold">
                        {header
                            ? header
                            : 'This is the closer. If you’re not convinced yet, no coffee for us.'}
                    </h2>
                    {customParagraph ? (
                        customParagraph
                    ) : (
                        <p
                            className="tw-mb-48"
                            dangerouslySetInnerHTML={{
                                __html: paragraph
                                    ? paragraph
                                    : 'Give us some details, not too much, not too little, just enough to talk to you about our results, company and what we believe in.'
                            }}
                        ></p>
                    )}
                    {customerQuote && (
                        <>
                            <div className="tw-border tw-border-neutral-dark tw-rounded tw-overflow-hidden tw-backdrop-blur-md">
                                {customerQuote.companyLogo && (
                                    <div className="tw-max-w-[200px] tw-p-12 tw-border-b-neutral-dark tw-border-r-neutral-dark tw-border-b tw-border-r tw-rounded-br">
                                        <GatsbyImage
                                            alt="Company Logo"
                                            className="tw-max-w-[300px] tw-max-h-[40px]"
                                            image={customerQuote.companyLogo.asset.gatsbyImageData}
                                            imgStyle={{ objectFit: 'contain' }}
                                        />
                                    </div>
                                )}
                                <div className="tw-grid md:tw-grid-cols-[70px_minmax(0px_,1fr)] tw-gap-24 tw-text-left tw-items-start tw-text-neutral-inverse tw-p-24">
                                    {customerQuote.authorImage ? (
                                        <div className="tw-max-w-[200px]">
                                            <GatsbyImage
                                                alt={customerQuote.author}
                                                image={
                                                    customerQuote.authorImage.asset.gatsbyImageData
                                                }
                                                className="tw-max-w-[150px] tw-mx-auto tw-rounded"
                                                imgStyle={{ objectFit: 'contain' }}
                                            />
                                        </div>
                                    ) : (
                                        <div />
                                    )}

                                    <div>
                                        <blockquote className="tw-text-lg tw-m-0 tw-text-neutral-inverse">
                                            {customerQuote.text}
                                        </blockquote>
                                        <div className="tw-grid tw-gap-24 tw-items-center">
                                            <p>
                                                <span className="tw-font-medium">
                                                    {customerQuote.author}
                                                </span>
                                                ,{' '}
                                                <span className="tw-font-light tw-text-neutral-dark-subdued">
                                                    {customerQuote.authorRole}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {includeBadges && (
                        <div className={`${customerQuote && 'tw-mx-auto tw-mt-48'}`}>
                            <G2Badges />
                        </div>
                    )}
                    {includeCustomerLogos && (
                        <CustomerLogos style={{ height: 'auto', marginTop: 50 }} />
                    )}
                </div>
                <div className="tw-max-w-[500px]">
                    <SignupForm formVariant="light" formId={formId} />
                    {includeContactOptions && <ContactOptionsInline />}
                </div>
            </div>
        </div>
    );
};

export default EndOfPageCtaWithForm;
